import React, { useEffect, useState } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import { shallowEqual, useSelector } from "react-redux";
import { Alert } from "react-bootstrap";
import GeneralFilter from "../../../components/GeneralFilter";
import Pagination from "react-js-pagination";
import { getCasesByStatuses } from "../../services/casesService";
import GeneralTable from "../../../components/GeneralTable";
import CaseContext from "../../../contexts/CaseContext";
import { IfHasRoleByLocalStorage } from "../../../../_metronic/_helpers";

const Tab = () => {
  window.currModule = "Tabulaciones";
  window.assignationColumn = "feaccostos";

  const suhbeader = useSubheader();
  suhbeader.setTitle("Tabulaciones");

  const [casesRecord, setCasesRecord] = useState([]);
  const [paramsPagination, setParamsPagination] = useState({
    activePage: 1,
    totalPages: null,
    itemsCountPerPage: null,
    totalItemsCount: 0,
  });

  const { nurse, role, permissions } = useSelector(
    ({ auth, nurse, role, permissions }) => ({
      nurse: auth.user?.nurse?.id,
      role: auth.user?.role,
      permissions: auth?.permissions,
    }),
    shallowEqual
  );

  const getAllCasesByStatus = (pageNumber) => {
    var queryParams = [];

    if (IfHasRoleByLocalStorage("ADMIN_REGION_CELULA")) {
      queryParams = ['&byRegion=true', '&byCell=true'];
    }

    getCasesByStatuses([7], pageNumber, queryParams).then((response) => {
      let hasDictumPermission = permissions.some(
        (permission) => permission.name === "Control de Costos"
      );
      if (
        hasDictumPermission &&
        role.name !== "Admin" &&
        role.name !== "ADMINAXA"
      ) {
        let filtered = response.data?.filter(
          (currCase) => currCase.nurseFollowId === nurse
        ); //|| (currCase.statusDictum === "Rechazo Definitivo" && currCase.caseStatusId === 6)
        setCasesRecord(filtered);
      } else {
        setCasesRecord(response.data);
      }

      setParamsPagination({
        activePage: pageNumber,
        totalPages: response.totalPages,
        itemsCountPerPage: response.size,
        totalItemsCount: response.totalElements,
      });
    });
  }

  const handlePageChange = async (pageNumber) => {
    setParamsPagination({ ...paramsPagination, activePage: pageNumber, updatePage: true });

    if (!paramsPagination.hasOwnProperty("fromFilter")) {
      getAllCasesByStatus(pageNumber);
    }
  }

  useEffect(() => {
    getAllCasesByStatus(paramsPagination.activePage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Alert
        variant="success"
        className="text-center"
        style={{ fontSize: "16px" }}
      >
        Tabulaciones
      </Alert>

      <CaseContext.Provider value={[
        casesRecord, setCasesRecord,
        paramsPagination, setParamsPagination
      ]}>
        <GeneralFilter
          statuses={[7, 8]}
          hideInsurance={true}
          hideHospitalInvoice={true}
          hidePresumptiveDiagnosis={true}
          hideRequiresTabulation={false}
          hideCategoryVip={true} />
      </CaseContext.Provider>

      <GeneralTable
        urlToGo="/tabulaciones_detalles/"
        data={casesRecord}
        activePage={paramsPagination.activePage}
        totalItemsCount={paramsPagination.totalItemsCount}
        hidePatientStatusColumn={true}
        hideAxaCategoryColumn={false}
        hideCelulaColumn ={false}
        reasonTitle="Estatus Dictamen"
        reason="Dictum"
        assignationColumn="feaccostos"
        currModule="Tabulaciones"
      />

      <div className="d-flex justify-content-center">
        <Pagination
          activePage={paramsPagination.activePage}
          itemsCountPerPage={paramsPagination.itemsCountPerPage}
          totalItemsCount={paramsPagination.totalItemsCount}
          pageRangeDisplayed={10}
          itemClass="page-item"
          linkClass="btn btn-light"
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default Tab;
